import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { fetchComplaints, clearError } from '../redux/Slice/complaintSlice';

export const useComplaints = () => {
  const dispatch = useDispatch();
  const { complaints, loading, error } = useSelector(state => state.complaints);

  const getComplaints = useCallback((params = {}) => {
    dispatch(fetchComplaints(params));
  }, [dispatch]);

  const clearComplaintError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const getFilteredComplaints = useCallback((status) => {
    return complaints.filter(complaint => complaint.status === status);
  }, [complaints]);

  return {
    complaints,
    loading,
    error,
    getComplaints,
    clearComplaintError,
    getFilteredComplaints
  };
};